import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { Box, styled } from "@mui/material";
import { MprcIconFa } from "components";
import React from "react";

/////////////////////////////////////////////////////////////////////////////////

type PollSize = 'small' | 'medium' | 'large';

export interface PollOptionContainerProps {
    variant: "available" | "computed";
    size: PollSize;
    clickable?: boolean;
}

export interface PollOptionBarProps {
    percent: number;
    highlighted?: boolean;
    size: PollSize;
}

export const PollOptionContainer = styled(
    "div",
    {
        shouldForwardProp: (propName: string) => propName != "percent" && propName != "highlighted" && propName != "size"
    })<PollOptionContainerProps>(
        ({ theme, variant, size, clickable }) => ({
            position: "relative",
            height: size == "small" ? "28px" : size == "medium" ? "38px" : "48px",
            border: "1px solid",
            borderRadius: size == "small" ? "16px" : size == "medium" ? "22px" : "28px",
            fontSize: size == "small" ? "12px" : size == "medium" ? "14px" : "16px",
            color: theme.palette.common.black,
            borderColor: variant === "computed" ? theme.palette.muted.main : theme.palette.primary.light,
            backgroundColor: variant === "computed" ? theme.palette.paper.dark : theme.palette.common.white,
            cursor: variant === "available" || clickable ? "pointer" : "auto",
            "&:hover": variant === "computed" ? {} : {
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.common.white
            }
        })
    );

export const PollOptionLabel = styled("div")(
    ({ theme }) => ({
        position: "absolute",
        top: "50%",
        transform: "translate(0, -50%)",
        paddingLeft: theme.spacing(1),
        zIndex: 1000,
        padding: theme.spacing(2),
        textWrap: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "95%"
    })
);

export const PollOptionBar = styled(
    Box,
    {
        shouldForwardProp: (propName: string) => propName != "percent" && propName != "highlighted" && propName != "size"
    })<PollOptionBarProps>(
        ({ theme, percent, highlighted }) => ({
            position: "absolute",
            top: 0,
            height: "100%",
            backgroundColor: highlighted === true ? theme.palette.success.main : theme.palette.muted.light,
            borderRadius: "16px",
            width: `${percent}%`,
        })
    );

////////////////////////////////////////////////////////////////////////////////

interface IPropsPollComputed {
    text: string;
    selected: boolean;
    percent: number;
    highlighted: boolean;
    size?: PollSize;
    onClick?: () => void;
}

export const MprcPollComputed: React.FC<IPropsPollComputed> = (props) => {

    const { text, selected, percent, highlighted, size = "small", onClick } = props;

    return (
        <PollOptionContainer variant={"computed"} size={size ?? "small"} clickable={onClick != undefined} onClick={onClick}>
            <PollOptionLabel>
                {text} &nbsp; {selected && <MprcIconFa icon={faCircleCheck} />}
            </PollOptionLabel>
            <PollOptionBar percent={percent} highlighted={highlighted} size={size ?? "small"} />
        </PollOptionContainer>
    );
};

interface IPropsPollAvailable {
    text: string;
    size?: PollSize;
    onClick?: () => void;
}

export const MprcPollAvailable: React.FC<IPropsPollAvailable> = (props) => {

    const { text, size = "small", onClick } = props;

    return (
        <PollOptionContainer variant={"available"} size={size ?? "small"} onClick={onClick}>
            <PollOptionLabel>{text}</PollOptionLabel>
        </PollOptionContainer>
    );
};
